module.exports = __webpack_public_path__ + "static/img/partner-agc.574ae76.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productService/partner/partner-agc.png
// module id = FsYS
// module chunks = 34